import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Interaction } from 'src/app/pages/interactions/interaction.model';

@Component({
  selector: 'app-left-right',
  templateUrl: './left-right.component.html',
  styleUrls: ['./left-right.component.scss']
})
export class LeftRightComponent implements OnInit {

  @Input() interaction: Interaction;
  @Output() addInteraction = new EventEmitter();

  leftRightForm = new FormGroup({
    domanda: new FormControl('', [Validators.required]),
    sottotitolo: new FormControl(''),
    info: new FormControl(''),
    lat: new FormControl(''),
    lng: new FormControl(''),
    hasImage: new FormControl(false, [Validators.required]),
    immagineDomanda: new FormControl(null),
    rispostaSinistra: new FormControl('', [Validators.required]),
    rispostaDestra: new FormControl('', [Validators.required])
  });

  constructor() { }

  ngOnInit(): void {
    if (this.interaction) { // devo riempire i field
      this.populateForm();
    } else {
      this.interaction = {interactionType: 'leftRight'};
    }
  }

  // convenience getter for easy access to form fields
  get f(): any {
    return this.leftRightForm.controls;
  }

  populateForm(): void {
    this.f.domanda.setValue(this.interaction.title);
    this.f.sottotitolo.setValue(this.interaction.subtitle);
    this.interaction.interactionData && this.interaction.interactionData.info ? this.f.info.setValue(this.interaction.interactionData.info) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lat.setValue(this.interaction.interactionData.coordinates.lat) : '';
    this.interaction.interactionData && this.interaction.interactionData.coordinates ? this.f.lng.setValue(this.interaction.interactionData.coordinates.lng) : '';
    this.interaction.image ? this.f.hasImage.setValue(true) : this.f.hasImage.setValue(false);
    this.interaction.image ? this.f.immagineDomanda.setValue(this.interaction.image) : this.f.immagineDomanda.setValue(null);
    this.f.rispostaSinistra.setValue(this.interaction.interactionData.risposte[0].label);
    this.f.rispostaDestra.setValue(this.interaction.interactionData.risposte[1].label);
  }

  setImageUrl(event, target): void {
    if(target === 'featuredImage') {
      this.f.immagineDomanda.setValue(event ? event.filename : null);
      this.interaction.image = event ? event.filename : null;
    }
  }

  validateDomanda(): boolean {
    if (!this.f.domanda.errors && !this.f.sottotitolo.errors) {
      if (this.f.hasImage.value) {
        if (this.f.immagineDomanda.value) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  setDomanda(): void {
    this.interaction.title = this.f.domanda.value;
    if (this.f.hasImage) {
      this.interaction.image = this.f.immagineDomanda.value;
    }
    this.interaction.subtitle = this.f.sottotitolo.value;
  }

  validateRisposte(): boolean {
    return !this.f.rispostaSinistra.errors && !this.f.rispostaDestra.errors;
  }

  setRisposte(): void {
    if (this.interaction.interactionData) {
      this.interaction.interactionData.risposte[0].label = this.f.rispostaSinistra.value;
      this.interaction.interactionData.risposte[1].label = this.f.rispostaDestra.value;
    } else {
      this.interaction.interactionData = {
        risposte: [
          {
            label: this.f.rispostaSinistra.value,
            value: false,
          },
          {
            label: this.f.rispostaDestra.value,
            value: false,
          }
        ]
      }
    }
  }

  validateRisultato(): boolean {
    return this.interaction.interactionData.risposte.filter(r => r.value).length;
  }

  setRisultatoLeftRight(index): void {
    this.interaction.interactionData.risposte = this.interaction.interactionData.risposte.map(r => {
      return {
        ...r,
        value: false
      }
    });
    this.interaction.interactionData.risposte[index].value = true;
  }

  onAddInteraction(): void {
    for (let index = 0; index < this.interaction.interactionData.risposte.length; index++) {
      this.interaction.interactionData.risposte[index].id = index + 1;
    }
    this.interaction.interactionData.info = this.f.info.value;
    this.interaction.interactionData.coordinates = {
      lat: this.f.lat.value,
      lng: this.f.lng.value
    }
    this.addInteraction.emit(this.interaction);
  }

}
